import React, { useState, useEffect } from 'react';
import { FaTimes } from 'react-icons/fa';

const ReportModal = ({ isOpen, onClose, onSubmit, messageId }) => {
  const defaultMessage = `Quiero reportar un error en la respuesta del Agente de Inteligencia Artificial.`;
  const [reportMessage, setReportMessage] = useState(defaultMessage);

  useEffect(() => {
    if (!isOpen) {
      setReportMessage(defaultMessage);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleSubmit = e => {
    e.preventDefault();
    onSubmit(reportMessage);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
      <div className="bg-white rounded-lg p-6 w-96 relative">
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
        >
          <FaTimes className="w-4 h-4" />
        </button>

        <h3 className="text-lg font-medium mb-4">
          Informar de un error en la respuesta
        </h3>

        <form onSubmit={handleSubmit}>
          <textarea
            value={reportMessage}
            onChange={e => setReportMessage(e.target.value)}
            className="w-full h-32 p-2 border border-gray-200 rounded-lg 
                     focus:outline-none focus:ring-2 focus:ring-gray-400"
          />

          <div className="flex justify-end mt-4">
            <button
              type="button"
              onClick={onClose}
              className="mr-2 px-4 py-2 text-gray-600 hover:text-gray-800"
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-red-500 text-white rounded-lg 
                       hover:bg-red-600 transition-colors"
            >
              Enviar
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ReportModal;
